import {ChangeDetectionStrategy, Component, OnInit} from "@angular/core";
import {animate, animateChild, query, state, style, transition, trigger} from "@angular/animations";
import {environment} from "../../../environments/environment";

@Component({
    selector: 'app-splash-screen',
    templateUrl: './splash-screen.component.html',
    styleUrls: ['./splash-screen.component.scss'],
    animations: [
        trigger('fadeOut', [
            transition(':leave', [
                query(':leave', animateChild(), {optional: true}),
                animate(300), style({opacity: 0})
            ]),
        ]),
        trigger('fadeIn', [
            state('in', style({opacity: 1})),
            transition(':enter', [
                query(':enter', animateChild(), {optional: true}),
                style({opacity: 0}), animate(300)
            ])
        ])
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SplashScreenComponent implements OnInit {

    appName = environment.appName;
    show = true;

    constructor() {
    }

    ngOnInit() {
    }
}